export const UploadStatus = {
    canceled: 'upload_canceled',
    start: 'upload_started',
    completed: 'upload_completed',
};
